import { FC, useEffect } from "preact/compat";
import { useApp } from "~/core/store";

const SettingsActions: FC = () => {
    const { settings, api } = useApp();

    useEffect(() => {
        if (settings.showInactiveProjects.value) {
            api.project.listenInactive();
        }
    }, [api.project, settings.showInactiveProjects.value]);

    return null;
};

export default SettingsActions;
